import React, {useContext} from 'react';
import IconButton from '../common/IconButton';
import {MenuIcon} from '../common/icons';
import {UserContext} from "../common/UserContext";
import {TemplateContext} from "../common/TemplateContext";
import LessonTitleControls from "./LessonTitleControls";
import NavigationDrawer from "./NavigationDrawer";
import {NavigationContext} from "../common/NavigationContext";
import {useScreenMode} from "../common/context/ScreenModeContext";

const HeaderDevelopment = props => {
    const { setNavVisible } = props;
    const {mobileScreenMode} = useScreenMode();
    const { user } = useContext(UserContext);
    const { name, setSeriesNavVisible, titleComponentName,  shortcutClass, shortcut } = useContext(TemplateContext);
    const { drawerComponentName, isDrawerVisible, setDrawerVisible } = useContext(NavigationContext);

    return (
        <>
            <div className={'ch-header'}>
                <IconButton
                    className={'ch-icon-btn-on-global ch-header-menu-icon'}
                    onClick={() => setNavVisible(true)}
                    size="large"
                    aria-label={'Navigation menu'}
                >
                    <MenuIcon />
                </IconButton>
                <div className="ch-header-title">{user.syllabusName}</div>
                <IconButton
                    className={'ch-icon-btn-on-global ch-header-menu-icon'}
                    onClick={() => { setSeriesNavVisible(true) }}
                    size="large"
                    aria-label={'Course selector'}
                >
                    <svg className={'ch-icon-sm'} aria-hidden={'true'}
                         dangerouslySetInnerHTML={{__html: '<use xlink:href="#navLessons-icon"/>'}}
                         viewBox='0 0 128 128'/>
                </IconButton>
            </div>
            {shortcut != undefined && titleComponentName === 'DefaultTitle' &&
                <div className={'ch-header ch-header-content'}>
                    {shortcut.iconClass && (
                        <div className={'ch-header-mobile-icon'} data-icon={shortcutClass}>
                            <svg width="30px" height="30px" viewBox="0 0 128 128" aria-hidden={'true'}>
                                <use href={'#' + shortcut.iconClass + (shortcut !== undefined && shortcut.darkBGVersion ? '-onDark' : '')}/>
                            </svg>
                        </div>
                    )}
                    <h1 className='ch-page-header-title--main'>{name}</h1>
                </div>
            }
            {titleComponentName === 'LessonTitle' &&
                <div className={'ch-header'}>
                    <LessonTitleControls />
                </div>
            }
            <NavigationDrawer
                visible={isDrawerVisible}
                parentMenu={null}
                componentName={drawerComponentName}
                mobileScreenMode={mobileScreenMode}
                callback={() => {setDrawerVisible(false);}}
            />
        </>
    );
}

export default HeaderDevelopment;